// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"240":"support","806":"user","933":"auth"}[chunkId] + "." + {"240":"ee09d263","806":"0c286f28","933":"0d0d487f"}[chunkId] + ".js";
};